import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { FiSettings } from "react-icons/fi";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { Navigate } from "react-router-dom";
import { Navbar, Footer, Sidebar, ThemeSettings } from "./components";
import { Dashboard, ColorPicker, S3FileManager, ViewFile } from "./pages";
import Login from "./components/login";
import APK from "./pages/APK";
import "./App.css";
import ResetPasswordModal from "./components/ResetPassword";

import { useStateContext } from "./contexts/ContextProvider";
import UserManage from "./pages/users";
import AwsManage from "./pages/aws";
import AclManage from "./pages/ACL";
import TenantForm from "./pages/Tenantassign";
import TenantAllocation from "./pages/TenantAllocation";
import FirstLogin from "./components/FirstLogin";
import AdminManage from "./pages/admin";
import HtmlPackage from "./pages/htmlPackage";
import Log from "./pages/Log";
import ViewHTMl from "./pages/viewhtml";
import GetFile from "./pages/vdownload";
import Callback from "./pages/Callback";
import GeToken from "./pages/GeToken";
import GetHtml from "./pages/GetHtml";
import ClientForm from "./pages/ClientForm";
import PageNotFound from "./pages/PageNotFound";
import Clientedit from "./pages/Clientedit";
import VideoManagement from "./pages/VideoManagement";
import ViewVideoFile from "./pages/ViewVideoFile";
import GetVideoToken from "./pages/GetVideoToken";
import GetEpms from "./pages/GetEpms";

const App = () => {
  const {
    setCurrentColor,
    setCurrentMode,
    currentMode,
    activeMenu,
    currentColor,
    themeSettings,
    setThemeSettings,
  } = useStateContext();
  const [isFirstLogin, setIsFirstLogin] = useState(false);
  const [subscriptionsData, setSubscriptionsData] = useState([]);
  //const [IsLoaded, setIsloaded] = useState(false);
  const [isResetPasswordPage, setIsResetPasswordPage] = useState(false);
  const localStoragedata = async () => {
    try {
      const storedData = await localStorage.getItem("accesstoken");

      if (storedData) {
        setIslogged(true);

        return true;
      } else {
        setIslogged(false);
        return false;
      }
    } catch (error) {
      console.error("Error parsing localStorage data:", error);
    }
  };
  const [isViewFilePage, setIsViewFilePage] = useState("");
  const [IsLogged, setIslogged] = useState(localStoragedata);

  const API_URL = process.env.REACT_APP_API_URL_V;
  useEffect(async () => {
    const currentThemeColor = localStorage.getItem("colorMode");
    const currentThemeMode = localStorage.getItem("themeMode");

    // fetchData();
    if (currentThemeColor && currentThemeMode) {
      setCurrentColor(currentThemeColor);
      setCurrentMode(currentThemeMode);
    }

    const path = window.location.pathname;
    if (
      path.startsWith("/viewfile") ||
      path.startsWith("/viewhtmlfile") ||
      path.startsWith("/getfile") ||
      path.startsWith("/getoken") ||
      path.startsWith("/gethtmltoken") ||
      path.startsWith("/share") ||
      path.startsWith("/viewvideo") ||
      path.startsWith("/videotoken") ||
      path.startsWith("/epms")
    ) {
      setIsViewFilePage(true);
    } else {
      setIsViewFilePage(false);

      const verifyToken = await localStorage.getItem("accesstoken");
      if (verifyToken) {
        const response = await fetch(`${API_URL}/auth/verifytoken`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": verifyToken,
          },
          body: JSON.stringify(),
        });
        if (!response.ok) {
          setIslogged(false);
          localStorage.removeItem("accesstoken");
          localStorage.removeItem("userData");
          window.location.reload();
        } else {
          setIslogged(true);
        }
      }
    }

    setIsResetPasswordPage(
      window.location.pathname.startsWith("/resetpassword")
    );

    setIsFirstLogin(window.location.pathname.startsWith("/firstlogin"));
  }, []);

  return (
    <div className={currentMode === "Dark" ? "dark" : ""}>
      <BrowserRouter>
        {isViewFilePage ? (
          <Routes>
            <Route path="/viewfile/:id" element={<ViewFile />} />
            <Route path="/viewvideo/:id" element={<ViewVideoFile />} />
            <Route path="/viewhtmlfile/:id" element={<ViewHTMl />} />
            <Route path="/getfile/:id" element={<GetFile />} />
            <Route path="/getoken/:id" element={<GeToken />} />
            <Route path="/share/:id" element={<GeToken />} />
            <Route path="/videotoken/:id" element={<GetVideoToken />} />
            <Route path="/gethtmltoken/:id" element={<GetHtml />} />
            <Route path="/epms" element={<GetEpms />} />
          </Routes>
        ) : isResetPasswordPage ? (
          <Routes>
            <Route
              path="/resetpassword/:token"
              element={<ResetPasswordModal />}
            />
          </Routes>
        ) : isFirstLogin ? (
          <Routes>
            <Route path="/firstlogin/:token" element={<FirstLogin />} />
          </Routes>
        ) : !IsLogged ? (
          <Login setIslogged={setIslogged} />
        ) : (
          <div className="flex relative dark:bg-main-dark-bg">
            <div className="fixed right-4 bottom-4 z-50">
              <TooltipComponent content="Settings" position="Center">
                <button
                  type="button"
                  onClick={() => setThemeSettings(true)}
                  style={{ background: currentColor, borderRadius: "50%" }}
                  className="text-3xl text-white p-2 hover:drop-shadow-xl hover:bg-light-gray"
                >
                  {/* <FiSettings /> */}
                  <span
                    style={{
                      mask: `url(/icons/settings-icon.svg) center no-repeat`,
                      WebkitMask: `url(/icons/settings-icon.svg) center no-repeat`,
                      maskSize: "contain", // Adjust the mask size here
                      WebkitMaskSize: "contain",
                      display: "block",
                      width: "35px",
                      height: "35px",
                      backgroundColor: "white",
                      transition: "background-color 0.3s",
                    }}
                  ></span>
                </button>
              </TooltipComponent>
            </div>

            {activeMenu ? (
              <div className="w-64 fixed sidebar  dark:bg-secondary-dark-bg ">
                <Sidebar />
              </div>
            ) : (
              <div className="w-20 fixed sidebar dark:bg-secondary-dark-bg">
                <Sidebar />
              </div>
            )}

            <div
              className={
                activeMenu
                  ? "dark:bg-main-dark-bg  min-h-screen md:ml-64 w-full "
                  : "dark:bg-main-dark-bg   min-h-screen md:ml-20 w-full"
              }
              style={{
                backgroundColor:
                  currentMode === "Light" ? "#f6f4f4" : "transparent",
                backgroundImage: currentMode === "Light" ? "url('bg.png')" : "",
                backgroundSize: `100vh`,
                backgroundPosition: "right",
                backgroundRepeat: "repeat-y",
                // height:"100vh",
              }}
            >
              <div
                className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full border-b border-gray-300"
                style={{
                  backgroundColor:
                    currentMode === "Light"
                      ? "#f6f4f4"
                      : `rgba(32, 35, 42, var(--tw-bg-opacity))`,
                  backgroundImage:
                    currentMode === "Light" ? "url('bg.png')" : "",
                  backgroundSize: `100vh`,
                  backgroundPosition: "right",
                  backgroundRepeat: "repeat-y",
                }}
              >
                <Navbar />
              </div>
              <div></div>
              <div>
                {themeSettings && <ThemeSettings />}

                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/users" element={<UserManage />} />
                  <Route path="/awsmanagement" element={<AwsManage />} />
                  <Route path="/clientmanagement" element={<AclManage />} />
                  <Route
                    path="/clientallocation"
                    element={<TenantAllocation />}
                  />
                  <Route path="/tenant/add" element={<TenantForm />} />
                  <Route
                    path="/addclient"
                    element={<ClientForm mode="create" />}
                  />
                  <Route path="/tenant/edit/:id" element={<TenantForm />} />
                  <Route path="/client/edit/:id" element={<Clientedit />} />
                  <Route path="/filemanager" element={<S3FileManager />} />
                  <Route path="/htmlpackage" element={<HtmlPackage />} />
                  <Route path="/log" element={<Log />} />
                  <Route path="/videomanager" element={<VideoManagement />} />
                  <Route path="/sso/callback" element={<Callback />} />
                  <Route
                    path="/apk"
                    element={
                      subscriptionsData.length > 0 ? (
                        <APK subscriptionsData={subscriptionsData} />
                      ) : (
                        <APK subscriptionsData={[]} />
                      )
                    }
                  />

                  <Route path="/color-picker" element={<ColorPicker />} />

                  <Route path="/login" element={<Navigate to="/dashboard" />} />
                  <Route path="/admin" element={<AdminManage />} />
                  <Route path="/admin/add" element={<AdminManage />} />
                  <Route path="/admin/edit/:id" element={<AdminManage />} />

                  <Route path="*" element={<PageNotFound />} />
                </Routes>
              </div>
              <Footer />
            </div>
          </div>
        )}
      </BrowserRouter>
    </div>
  );
};

export default App;
